// extracted by mini-css-extract-plugin
export default {"icon-button":"icon-button_icon-button__7D4s2","icon-button--disabled":"icon-button_icon-button--disabled__gltOC"};